import { APPLE_COMMAND_KEY } from './constants';
/**
 * The english translations.
 */
export const en = {
    gestureHandlingTouch: 'Use two fingers to move the map',
    gestureHandlingScroll: 'Use ctrl + scroll to zoom the map',
    gestureHandlingScrollMac: `Use ${APPLE_COMMAND_KEY} + scroll to zoom the map`,
    Transparency: 'Transparency',
};
//# sourceMappingURL=en.js.map